import styles from "./NoInternet.module.scss";
import { FC } from "react";

const NoInternet: FC<{
  isOnline: boolean;
}> = ({ isOnline }) => {
  return (
    <div style={{ display: isOnline ? "none" : "block" }}>
      <div className={styles["no-internet-container"]}>
        <div className={styles["no-internet-container__image"]}>
          <img src="/images/NoInternet.svg" />
        </div>
        <div className={styles["no-internet-container__title"]}>
          No Internet
        </div>
        <div className={styles["no-internet-container__message"]}>
          Slow or no internet connection. Please check your internet settings
        </div>
      </div>
    </div>
  );
};

export default NoInternet;
